import { render } from "./PopupResMoreInfo.vue?vue&type=template&id=0ae82c6c&scoped=true"
import script from "./PopupResMoreInfo.vue?vue&type=script&lang=js"
export * from "./PopupResMoreInfo.vue?vue&type=script&lang=js"

import "./PopupResMoreInfo.vue?vue&type=style&index=0&id=0ae82c6c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae82c6c"]])

export default __exports__